/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentInfoAPI
 * @hideconstructor
 * @classdesc API class that is used to return widget serviceability information
 */
define([], () => {
	class ContentInfoAPI {
		/**
		 * @public
		 * @function ContentInfoAPI#getId
		 * @description get widget ID
		 */
		getId() {}

		/**
		 * @public
		 * @function ContentInfoAPI#getType
		 * @description Get widget type
		 * @returns {string} type of the content
		 */
		getType() {}

		/**
		 * @public
		 * @function ContentInfoAPI#getVisTypeLabel
		 * @description retrieves the visualization type label
		 * @returns {string} the label for the visualization type
		 */
		getVisTypeLabel() {}

		/**
		 * @public
		 * @function ContentInfoAPI#setData
		 * @description set a custom data property
		 * @param {string} key - data key; must be a string; logs an error when it is not
		 * @param {Object} value - data value; can have a toJson method used when generating the spec 
		 * @returns undefined
		 */
		setData() {}

		/**
		 * @public
		 * @function ContentInfoAPI#getData
		 * @description Get the value stored with passed key
		 * @param {string} key - data key
		 * @returns the associated data or underfined if not found or key is invalid
		 */
		getData() {}


		/**
		 * @public
		 * @function ContentInfoAPI#getSpec
		 * @description Get widgetInfo spec
		 * @returns {Object} json object representing the s12y info
		 */
		getSpec() {}

		/**
		 * @public
		 * @function ContentInfoAPI#toUIJSON
		 * @description Get a json which defines the UI. The json will be consumed by ServiceabilityContent
		 * class where the required structure of the json is explained. This method will try to call each
		 * "toUIJSON" for each data. The "toUIJSON" of each data shoule return an array of sections.
		 * @param {Object} [options] - options object
		 * @param {string} [options.mode] - json mode; available modes: 'overlay'
		 * @returns {Array} json object
		 */
		toUIJSON() {}
	}

	return ContentInfoAPI;
});
